export default __webpack_public_path__ + "static/media/facebook-auth-white.efa0fed9.svg";